var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgK18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5230_24383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9777 19.0174C22.2518 18.7432 22.2518 18.2972 21.9777 18.023C21.7035 17.7488 21.2574 17.7488 20.9833 18.023C20.7092 18.2971 20.7092 18.7432 20.9833 19.0174C21.2575 19.2915 21.7035 19.2915 21.9777 19.0174Z",
    fill: "url(#paint0_radial_5230_24383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9833 13.3824C19.9766 14.3892 19.6231 15.8049 19.9212 17.0997C19.9432 17.0756 19.9657 17.0518 19.989 17.0285C20.8114 16.206 22.1496 16.206 22.9721 17.0285C23.7945 17.8509 23.7945 19.1891 22.9721 20.0115C22.9488 20.0348 22.925 20.0573 22.9009 20.0793C24.1956 20.3774 25.6114 20.024 26.6181 19.0172C28.1716 17.4637 28.1716 14.9359 26.6181 13.3824C25.0646 11.8289 22.5369 11.8289 20.9833 13.3824V13.3824ZM23.4693 15.2054C23.1947 15.48 22.7495 15.48 22.4749 15.2054C22.2003 14.9309 22.2003 14.4857 22.4749 14.2111C22.7495 13.9365 23.1947 13.9365 23.4693 14.2111C23.7439 14.4856 23.7439 14.9309 23.4693 15.2054ZM25.7895 17.5256C25.5149 17.8002 25.0697 17.8002 24.7951 17.5256C24.5205 17.251 24.5205 16.8059 24.7951 16.5313C25.0697 16.2567 25.5149 16.2567 25.7895 16.5313C26.0641 16.8059 26.0641 17.251 25.7895 17.5256Z",
    fill: "url(#paint1_radial_5230_24383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3259 14.0737L11.9168 16.4827L16.0744 31.999C17.0643 32.014 18.0563 31.8513 18.9981 31.511L14.3259 14.0737Z",
    fill: "url(#paint2_radial_5230_24383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2929 30.9099C20.9034 30.5585 21.4783 30.1227 21.9996 29.6014L25.4516 26.1494L18.5196 24.292L20.2929 30.9099Z",
    fill: "url(#paint3_radial_5230_24383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6012 22.0002C32.7995 18.8018 32.7995 13.5976 29.6012 10.3993C26.4028 7.20089 21.1986 7.20089 18.0002 10.3993L15.474 12.9255L18.0994 22.7238L26.5999 25.0015L29.6012 22.0002ZM19.9889 12.388C22.0907 10.2862 25.5106 10.2862 27.6124 12.388C29.7142 14.4898 29.7142 17.9097 27.6124 20.0115C25.5106 22.1132 22.0908 22.1132 19.989 20.0115C17.8871 17.9097 17.8871 14.4898 19.9889 12.388V12.388Z",
    fill: "url(#paint4_radial_5230_24383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7686 17.6309L10.3988 18.0007C7.20041 21.1991 7.20041 26.4033 10.3988 29.6017C11.5837 30.7867 13.0441 31.5321 14.5757 31.839L10.7686 17.6309Z",
    fill: "url(#paint5_radial_5230_24383)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5230_24383",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5947 19.6334) rotate(-90) scale(2.16304 6.45657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5230_24383",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4482 22.5071) rotate(-90) scale(12.256 36.5846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5230_24383",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0328 37.2344) rotate(-90) scale(27.5862 32.5286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5230_24383",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5489 32.8423) rotate(-90) scale(10.1841 31.8427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5230_24383",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.0797 29.9658) rotate(-90) scale(26.1624 75.9133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5230_24383",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8221 35.9878) rotate(-90) scale(21.8646 30.2059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5230_24383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK18);
export default __webpack_public_path__ + "static/media/K18.1eb6c8b0c9a5e5ec179e68b5f9a4d96c.svg";
export { ForwardRef as ReactComponent };